var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative mt-12 lg:mt-24 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center"},[_c('div',[_c('features-one-title'),_c('features-one-list')],1),_c('features-one-svg')],1)}
var staticRenderFns = []

export { render, staticRenderFns }